export default __webpack_public_path__ + "static/media/a037-4.604bb0a5.svg";